import React from "react";
import "./Main.scss";
import { IBlockElement } from "../../../types/IBlockElement";

export default function Main({ id, className, children, onClick, onChange }: IBlockElement) {
    return <main id={id} className={className} onClick={onClick} onChange={onChange}>{children}</main>;
}